export default __webpack_public_path__ + "static/solution_hero-90e6be200524f3d9120a363a22505a7f.png";